/** Small pill naming an attraction's category, tinted with its colour. */
export function CategoryBadge({
  name,
  color,
  onImage = true,
}: {
  name: string;
  color: string;
  /** On a photo: frosted white pill. Elsewhere: soft tint of the category colour. */
  onImage?: boolean;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold tracking-wide ${
        onImage
          ? "bg-white/90 text-[#242a27] shadow-sm backdrop-blur"
          : "bg-forest-50 text-bark"
      }`}
    >
      <span
        className="h-2 w-2 rounded-full"
        style={{ backgroundColor: color }}
        aria-hidden
      />
      {name}
    </span>
  );
}
